import { db } from '@/main'
import { reject } from 'eslint-plugin-promise/rules/lib/promise-statics'

export default {
  namespaced: true,
  state: {
    active: false,
    api: '',
    branches: [],
    categories: [],
    menus: [],
    messages: {},
    name: '',
    documentId: '',
    paymentMethods: [],
    nextInvoice: '',
    registeredLocation: {},
    vat: 0.1,
    totalOrders: 0,
    totalUsers: 0,
    businessHours: [],
    linkedFacebookPage: null,
    timeZone: '',
    lang: [],
    loading: false,
    error: null
  },
  mutations: {
    analytics(state, payload) {
      // console.log('nextInvoice', typeof payload.nextInvoice)
      state.documentId = payload.documentId
      state.active = payload.active
      state.api = payload.api
      state.branches = payload.branches
      state.categories = payload.categories
      state.menus = payload.menus
      state.name = payload.name
      state.messages = payload.messages
      state.paymentMethods = payload.paymentMethods
      state.nextInvoice = payload.nextInvoice
      state.registeredLocation = payload.registeredLocation
      state.vat = payload.vat
      state.totalOrders = payload.totalOrders
      state.totalUsers = payload.totalUsers
      state.linkedFacebookPage = payload.linkedFacebookPage
      state.lang = payload.lang || []
      if (!payload.businessHours) {
        const week = [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ]
        state.businessHours = week.map((x) => ({
          day: x,
          start: '',
          end: ''
        }))
      } else {
        state.businessHours = payload.businessHours
      }
      if (!payload.timeZone) {
        state.timeZone = 'Asia/Phnom_Penh'
      } else {
        state.timeZone = payload.timeZone
      }
    },
    error(state, payload) {
      state.error = payload
    },
    startAction(state) {
      state.error = null
      state.loading = true
    },
    stopAction(state) {
      state.loading = false
    }
  },
  actions: {
    /**
     * @func
     * @desc query all current tenant analytics
     *   by using onSnapshot listener
     *   this function will also be invoked automatically if there is any changes at remote
     *   so you don't have to update any client side store
     * @param [context]
     */
    subscribeTenant(context) {
      db.collection('tenants')
        .doc(context.rootState.account.tenantId)
        .onSnapshot((querySnapshot) => {
          // console.log('tenant', querySnapshot.data())
          const data = querySnapshot.data()
          data.documentId = querySnapshot.id
          context.commit('analytics', data)
        })
    },
    startIntervalDate(context) {
      return new Promise((resolve, reject) => {
        if (context.state.nextInvoice) {
          return resolve({
            timestamp: new Date(
              context.state.nextInvoice
                .toDate()
                .setMonth(context.state.nextInvoice.toDate().getMonth() - 1, 1)
            )
          })
        }
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .get()
          .then((querySnapshot) => {
            // console.log('tenant', querySnapshot.data())
            if (!querySnapshot) {
              return reject(new Error('Next Invoice Date Not Found'))
            }
            const nextInvoice = querySnapshot.data().nextInvoice
            // console.log('queried next invoice', nextInvoice.toDate())
            return resolve({
              timestamp: new Date(
                nextInvoice
                  .toDate()
                  .setMonth(nextInvoice.toDate().getMonth() - 1)
              )
            })
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    setBusinessHour(context, payload) {
      return new Promise((resolve, reject) => {
        const work = payload.newBusHour.map((x) => ({
          day: x.day,
          start: x.start,
          end: x.end
        }))
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .set(
            {
              businessHours: work,
              timeZone: payload.timeZone
            },
            { merge: true }
          )
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    createCategory(context, payload) {
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .update({
            categories: payload
          })
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    createMenu(context, payload) {
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .update({
            menus: payload
          })
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    createTenant(context, payload) {
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .update({
            branches: [{ name: payload, active: true }]
          })
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    UpdateVAT(context, payload) {
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .update({
            vat: payload
          })
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    updateBranch(context, payload) {
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .update({
            branches: payload
          })
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    updateWelMss(context, payload) {
      return new Promise((resolve, reject) => {
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .update({
            'messages.introduce': payload
          })
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            return reject(error)
          })
      })
    },
    updatePayment(context, payload) {
      return new Promise((resolve, reject) => {
        context.state.paymentMethods[payload.id] = payload.paymentMethod
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .update({
            paymentMethods: context.state.paymentMethods
          })
          .then(() => {})
          .catch((error) => {
            return reject(error)
          })
      })
    },
    addPayment(context, payload) {
      db.collection('tenants')
        .doc(context.rootState.account.tenantId)
        .update({
          paymentMethods: payload
        })
        .then(() => {})
        .catch((error) => {
          return reject(error)
        })
    },

    setLanguage(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startAction')
        if (!payload.includes('en')) {
          reject(new Error('en is required'))
          return context.commit('stopAction')
        }
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .set(
            {
              lang: payload
            },
            { merge: true }
          )
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    }
  },
  getters: {
    activeBranches(state) {
      if (!state.branches || state.branches.length < 1) {
        return []
      }
      return state.branches.filter((x) => x.active)
    },
    branches(state, getters) {
      return getters.activeBranches.map((x) => {
        return x.name
      })
    }
  }
}
